

import {Component, Ref} from "vue-property-decorator";
import {IMaterial, MaterialType} from "shared/entities/material";
import {mixins} from "vue-class-component";
import AuthMixin from "@/mixins/auth.mixin";
import {Api} from "shared/api";
import {apiHandler} from "@/services/api-handler";
import pdf from "vue-pdf";
import PdfDisplay from "@/components/pdf-display.vue";

@Component({
    components: {PdfDisplay, pdf}
})
export default class ViewMaterial extends mixins(AuthMixin) {
    material: IMaterial | null = null;
    MaterialType = MaterialType;
    showQuiz = false;
    answers: Record<number, number> = [];
    @Ref("video") readonly video!: HTMLVideoElement;
    videoIsDone = false;
    completed = false;

    currentDocumentTotalPages = 0;


    get allAnswered() {
        if (this.material === null) return false;
        for (const questionIdx in this.material.questions) {
            if (!this.answers.hasOwnProperty(questionIdx)) return false;
        }
        return true;
    }

    get finishedMaterial() {
        if (this.material?.type === MaterialType.Video) {
            return this.videoIsDone;
        }
        return true;
    }

    async mounted() {
        const allCompleted = await apiHandler(() => Api.material.completed.Get());
        this.material = await apiHandler(() => Api.material[this.$route.params.id].Get());
        this.completed = allCompleted.hasOwnProperty(this.material.id);
    }

    async completedMaterial() {
        if (this.material === null) return false;
        if (this.material.hasQuiz) {
            this.showQuiz = true;
        } else {
            alert("Section Complete");
            await this.sendCompleted();
        }
    }

    async completedQuiz() {
        if (this.material === null) return;
        let userScore = 0;
        let totalScore = 0;
        for (const questionIdx in this.material.questions) {
            totalScore++;
            if (this.answers.hasOwnProperty(questionIdx) && this.answers[questionIdx] === this.material?.questions[questionIdx].correctAnswer) userScore++;
        }
        if (userScore/totalScore >= 0.7) {
            alert(`Quiz Passed with ${userScore}/${totalScore}, Section Complete`);
            await this.sendCompleted(userScore);
        }
        else {
            alert(`Quiz failed with ${userScore}/${totalScore}, please review your answers, or restart the section.`);
        }
    }

    async sendCompleted(score?: number) {
        if (this.material === null) return;
        const id = this.material.id;
        await apiHandler(() => Api.material[id].completed.Post({score}));
        await this.$router.push("/");
    }
}

